import { Input, InputGroup, InputRightElement } from "@chakra-ui/react";
import { ReactNode } from "react";

interface InputProps {
  inputRightElement?: ReactNode;
  value: string;
  error?: string;
  //   isDisabled?: boolean;
  //   maxFractionDigits: number;
  onChange?: (val: string) => void;
  disabled?: boolean;
}

const StableTicketInput = ({
  inputRightElement,
  value,
  onChange,
  error,
  disabled = false,
}: InputProps) => {
  return (
    <InputGroup size="md" mt="12px">
      <Input
        type="text"
        variant="unstyled"
        placeholder="0.0"
        borderRadius="9px"
        bg="#D8F0F0"
        border="1px solid #B6DFDF"
        p="6px 6px 6px 14px"
        h="48px"
        color="textPrimary"
        fontWeight="600"
        fontSize="20px"
        lineHeight="24px"
        value={value}
        isInvalid={!!error}
        onChange={(e) => onChange?.(e.target.value)}
        borderColor={error ? "error" : "backgroundDivider"}
        _placeholder={{
          color: "textTertiary",
        }}
        _disabled={{ bgColor: "#F5F5F7", color: "textTertiary" }}
        disabled={disabled}
      />

      {inputRightElement && (
        <InputRightElement my="auto" h="100%" w="auto" mt={"20px"} mr="6px">
          {inputRightElement}
        </InputRightElement>
      )}
    </InputGroup>
  );
};

export default StableTicketInput;
